export class AuthenticationClientConfig {
    constructor(){
        throw new Error('AuthenticationClientConfig ctor was called, expected to be overridden by IOC');
    }

    baseURL: string;
}
